import * as React from 'react';

function Footer(_ref) {
  var children = _ref.children;
  return React.createElement("tfoot", null, children);
}

export default Footer;